import cx from '../../../../utils/cx';

import styles from './Typography.module.scss';

export const FONT_TYPES = {
  h1: 'h1',
  h2: 'h2',
  brand: 'brand',
  percent: 'percent',
  button: 'button',
  body_bold: 'body_bold',
  body_semibold: 'body_semibold',
  body_regular: 'body_regular',
  small_regular: 'small_regular',
  mini_bold: 'mini_bold',
  mini_regular: 'mini_regular',
};

const TYPE_TO_TAG = {
  [FONT_TYPES.h1]: 'h1',
  [FONT_TYPES.h2]: 'h2',
};

const Typography = ({ className, type, isCenter, htmlTag, children }) => {
  const HtmlTag = htmlTag || TYPE_TO_TAG[type] || 'span';

  return (
    <div className={cx(styles.wrapper, className, { [styles.center]: isCenter })}>
      <HtmlTag className={styles[type] || styles.body_regular}>{children}</HtmlTag>
    </div>
  );
};

export default Typography;
